<p-columnfilter [field]="field" display="menu" matchMode="dateRange" [showMatchModes]="false" [showOperator]="false"
    [showAddButton]="false">
    <ng-template #filter let-value let-filter="filterCallback">
        <div class="flex flex-col gap-3 min-w-80">
            <div class="grid grid-cols-2 gap-2">
                @for (preset of presets; track preset.key) {
                <p-button [label]="preset.label" size="small" severity="secondary" styleClass="w-full"
                    (onClick)="filter(getPreset(preset.key))"></p-button>
                }
            </div>
            <p-datepicker [ngModel]="value" (ngModelChange)="filter($event)" selectionMode="range" dateFormat="yy-mm-dd"
                placeholder="Custom range" [showIcon]="true" [showClear]="true" appendTo="body" styleClass="w-full">
            </p-datepicker>
        </div>
    </ng-template>
</p-columnfilter>